import { render } from "./FunZhishu.vue?vue&type=template&id=3f89f5bd"
import script from "./FunZhishu.vue?vue&type=script&lang=js"
export * from "./FunZhishu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__